<template>
  <v-navigation-drawer
    id="drawer"
    v-model="drawer"
    app
    mobile-break-point="991"
    width="260"
    :mini-variant.sync="mini"
  >
    <v-layout class="fill-height" tag="v-list" column>
      <v-list-tile avatar>
        <v-list-tile-avatar color="white">
          <v-img :src="logo" height="23" contain />
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title class="title">{{ appName }}</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon @click.stop="mini = !mini">
            <v-icon>chevron_left</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>

      <v-divider />

      <v-list>
        <template v-for="(item, index) in items">
          <v-list-tile
            v-if="item.path"
            :key="item.title"
            :to="item.path"
            :active-class="color"
            avatar
            class="v-list-item"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-title> {{ item.title }} </v-list-tile-title>
          </v-list-tile>

          <v-subheader
            v-else-if="item.header"
            :key="item.header"
            v-html="item.header"
          ></v-subheader>

          <v-divider
            v-else-if="item.divider"
            :key="index"
            :inset="item.inset"
          ></v-divider>

          <v-list-group
            v-else
            no-action
            :prepend-icon="item.icon"
            :key="item.title"
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </template>

            <v-list-tile
              v-for="subItem in item.items"
              :key="subItem.title"
              :to="subItem.path"
              :active-class="color"
              avatar
              class="v-list-item"
            >
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>

              <v-icon>{{ subItem.icon }}</v-icon>
            </v-list-tile>
          </v-list-group>
        </template>
      </v-list>

    </v-layout>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'Drawer',

  created () {
    this.items = this.$store.state.drawerOptions
    let appConf = this.$store.state.appConf
    this.appName = appConf.appName
    this.logo = appConf.logo
  },

  watch: {
    '$store.state.drawerOptions': function () {
      this.items = this.$store.state.drawerOptions
    }
  },

  computed: {
    drawer: {
      get () {
        return this.$store.state.drawer
      },
      set (val) {
        this.$store.commit('toggle_drawer', val)
      }
    }
  },

  data: function () {
    return {
      appName: null,
      logo: null,
      items: null,
      mini: false
    }
  }
}
</script>
